import { render, staticRenderFns } from "./ReviewAndSocial.vue?vue&type=template&id=814dd018&scoped=true"
import script from "./ReviewAndSocial.vue?vue&type=script&lang=js"
export * from "./ReviewAndSocial.vue?vue&type=script&lang=js"
import style0 from "./ReviewAndSocial.vue?vue&type=style&index=0&id=814dd018&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814dd018",
  null
  
)

export default component.exports